var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Pagination, PaginationDisplayedItemCount, } from '@one-thd/sui-atomic-components';
import React from 'react';
import { usePurchaseHistoryContext } from '../../../hooks/useContexts';
import { getNumPages, getWindow } from '../../../utils/general';
export var ODTablePagination = function () {
    var _a;
    var _b = usePurchaseHistoryContext(), localDeliveryData = _b.localDeliveryData, lDRequest = _b.lDRequest, setLDRequest = _b.setLDRequest;
    var totalNumberOfODOrders = (_a = localDeliveryData === null || localDeliveryData === void 0 ? void 0 : localDeliveryData.orderCount) !== null && _a !== void 0 ? _a : 0;
    return (React.createElement("div", { className: "sui-grow", "data-testid": "pagination-compact-and-item-count-local-delivery" },
        React.createElement("div", { className: "sui-relative sui-flex sui-items-center sui-gap-4 sui-flex-col-reverse sm:sui-flex-row sm:sui-gap-0" },
            React.createElement(PaginationDisplayedItemCount, { page: lDRequest.pageNumber, itemsPerPage: 20, items: totalNumberOfODOrders }),
            React.createElement(Pagination, { count: getNumPages(20, totalNumberOfODOrders), page: lDRequest.pageNumber, onChange: function (_event, selectedPage) {
                    var _a;
                    setLDRequest(function (prevState) {
                        return __assign(__assign({}, prevState), { pageNumber: selectedPage });
                    });
                    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0 });
                }, siblingCount: 1, boundaryCount: 1, showFirstButton: true, showLastButton: true }))));
};
